const Error = () => (
    <svg
        width='49'
        height='49'
        viewBox='0 0 49 49'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M44 44L5 5M44 5L5 44'
            stroke='#F8F8F8'
            strokeWidth='8.16279'
            strokeLinecap='round'
        />
    </svg>
);

export default Error;
